













import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class LengthCounter extends Vue {
  @Prop({ required: true })
  private readonly text!: string;
  @Prop({ required: true })
  private readonly maxLength!: number;
}
